import i18n from "../../utils/i18n";
import en from "./en.json";
import tr from "./tr.json";

/**
 * Yeni tasarımın kendi çeviri ad alanı: aynı anahtarın eski ekranlardaki
 * karşılığı farklı olduğu için src/languages/*.json'a dokunulmaz.
 * Anahtarlarda iki nokta kullanılmaz, o karakter ad alanı ayırıcısıdır.
 */
export const REDESIGN_NS = "redesign";

i18n.addResourceBundle("tr", REDESIGN_NS, tr, true, true);
i18n.addResourceBundle("en", REDESIGN_NS, en, true, true);
